import { activeConfig } from "config/site.config";
import { PopupRequest } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: activeConfig.clientId,
    authority: `https://login.microsoftonline.com/${activeConfig.authority}`,
    redirectUri: activeConfig.redirectUri
  
  },
  //   auth: {
//     clientId: 'aaefd9cf-5604-4e27-ad70-04a737410d51',
//     authority: 'https://login.microsoftonline.com/647119b9-2120-453d-ab27-e02884c15a1b',
//     redirectUri: 'https://test.seanergydigital.com/orderentry/dashboard',
//     // clientId: 'b6c78d1e-12f7-4e87-95fa-78c142190cfc',
//     // authority: 'https://login.microsoftonline.com/23293be7-6169-47c7-9664-eb3842ccc7dc',
//     // redirectUri: 'https://plgtst.pegasuslogistics.com/orderentry/dashboard'
//     // clientId: 'b6c78d1e-12f7-4e87-95fa-78c142190cfc',
//     // authority: 'https://login.microsoftonline.com/23293be7-6169-47c7-9664-eb3842ccc7dc',
//     // redirectUri: 'https://oebp.pegasuslogistics.com/dashboard'
  
//   },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
};

export const loginRequest: PopupRequest = {
  scopes: ["user.read"]
};